import { render, staticRenderFns } from "./foot-btn.vue?vue&type=template&id=9c35ac9a&scoped=true"
import script from "./foot-btn.vue?vue&type=script&lang=js"
export * from "./foot-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c35ac9a",
  null
  
)

export default component.exports